var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "upPictureBox"
    }
  }, [_c('header', [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: _vm.activeName,
      callback: function ($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('kioskHost.logo'),
      "name": "Logo"
    }
  }), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('kioskHost.background'),
      "name": "Background"
    }
  })], 1)], 1), _c('section', {
    staticClass: "configModule"
  }, [_c('div', {
    staticClass: "uploadBox cursor"
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "#",
      "accept": "image/*",
      "show-file-list": false,
      "http-request": _vm.uploadFileBySDK,
      "on-change": _vm.handleChange,
      "before-upload": _vm.judgeAllowUpload
    }
  }, [_vm.imageUrl ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_vm._v(_vm._s(_vm.$t('addTvuOne.adds')))])])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showPosition,
      expression: "showPosition"
    }],
    staticClass: "positionBox hide"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('kioskHost.placingPositionSetting')))]), _c('i', {
    staticClass: "el-icon-setting pointer right",
    on: {
      "click": function ($event) {
        _vm.positionInfo.show = true;
      }
    }
  })])]), _c('main', {
    staticClass: "pictureMdole"
  }, [_c('div', {
    staticClass: "pictureMdole-head"
  }, [_vm._v(_vm._s(_vm.$t('kioskHost.imageList')))]), _c('div', {
    staticClass: "pictureMdole-content scrollbar"
  }, [_c('draggable', {
    on: {
      "change": _vm.change,
      "end": _vm.dragEnd
    },
    model: {
      value: _vm.pictureList,
      callback: function ($$v) {
        _vm.pictureList = $$v;
      },
      expression: "pictureList"
    }
  }, [_c('transition-group', _vm._l(_vm.pictureList, function (val) {
    return _c('div', {
      key: val.name,
      staticClass: "list",
      class: _vm.showActive(val.name),
      on: {
        "click": function ($event) {
          return _vm.selectPicture(val);
        }
      }
    }, [_c('img', {
      class: {
        logoImg: _vm.activeName === 'Logo' ? true : false
      },
      attrs: {
        "src": val.url
      }
    }), _c('span', {
      staticClass: "ellipsis",
      attrs: {
        "title": val.name
      }
    }, [_vm._v(_vm._s(val.name))]), _c('i', {
      staticClass: "el-icon-s-fold"
    }), _c('i', {
      staticClass: "el-icon-delete",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.deleteUpload($event, val);
        }
      }
    })]);
  }), 0)], 1)], 1)]), _c('el-button', {
    staticClass: "bgConfirmBtn green",
    on: {
      "click": _vm.applyImg
    }
  }, [_vm._v(_vm._s(_vm.$t('startNewParty.apply')))])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };